export default class CybersourceManager {
	static getFingerprint(merchantID: string, orgID: string): string {
		const sessionID = new Date().getTime();

		const metrixContainer = document.createElement('div');
		metrixContainer.id = 'metrics';
		metrixContainer.style.position = 'absolute';
		metrixContainer.style.top = '0';
		metrixContainer.style.opacity = '0';
		metrixContainer.style.width = '1px';
		metrixContainer.style.height = '1px';
		document.body.appendChild(metrixContainer);

		const paragraphTM: any = document.createElement('p');
		paragraphTM.styleSheets = `background:url(https://h.online-metrix.net/fp/clear.png?org_id=${orgID}&session_id=${merchantID}${sessionID}&m=1)`;
		metrixContainer.appendChild(paragraphTM);

		const img = document.createElement('img');
		img.src = `https://h.online-metrix.net/fp/clear.png?org_id=${orgID}&session_id=${merchantID}${sessionID}&m=2`;
		img.alt = '';
		metrixContainer.appendChild(img);

		const objectTM = document.createElement('object');
		objectTM.data = `https://h.online-metrix.net/fp/fp.swf?org_id=${orgID}&session_id=${merchantID}${sessionID}`;
		objectTM.type = 'application/x-shockwave-flash';
		objectTM.width = '1';
		objectTM.height = '1';
		objectTM.id = 'thm_fp';

		const param = document.createElement('param');
		param.name = 'movie';
		param.value = `https://h.online-metrix.net/fp/fp.swf?org_id=${orgID}&session_id=${merchantID}${sessionID}`;

		objectTM.appendChild(param);
		metrixContainer.appendChild(objectTM);

		const tmscript = document.createElement('script');
		tmscript.src = `https://h.online-metrix.net/fp/tags.js?org_id=${orgID}&session_id=${merchantID}${sessionID}`;
		tmscript.type = 'text/javascript';
		document.body.appendChild(tmscript);

		return `${sessionID}`;
	}
}
